export default __webpack_public_path__ + "static/media/Streets.1256db93.png";